import { useAuthorization } from '@/authorization';
import type { ProductRegistryPermission } from '@/types/productRegistry';

function normalizePermission(permission: string): string {
  return permission.trim().toUpperCase();
}

export function hasProductRegistryPermission(
  permission: ProductRegistryPermission | string | undefined,
  permissionTokens: string[] = [],
): boolean {
  if (!permission) {
    return true;
  }

  const normalizedPermission = normalizePermission(permission);
  const normalizedTokens = new Set(permissionTokens.map(normalizePermission));

  if (normalizedTokens.has('*')) {
    return true;
  }

  return normalizedTokens.has(normalizedPermission);
}

export function useProductRegistryPermission(
  permission: ProductRegistryPermission | string | undefined,
): boolean {
  const { hasPermission } = useAuthorization();

  if (!permission) {
    return true;
  }

  return hasPermission(permission);
}
